<template functional>
  <span
    :aria-hidden="props.decorative"
    :aria-label="props.title"
    :class="[data.class, data.staticClass]"
    v-bind="data.attrs"
    class="material-design-icon access-point-off-icon"
    role="img"
    v-on="listeners">
    <svg
      :fill="props.fillColor"
      :width="props.size"
      :height="props.size"
      class="material-design-icon__svg"
      viewBox="0 0 24 24">
      <path
      d="M17.4 17.4v1.8H4.8c-.477 0-.935-.19-1.273-.527C3.19 18.335 3 17.877 3 17.4v-9h1.8v9h12.6zM21 6.6v7.2c0 .477-.19.935-.527 1.273-.338.337-.796.527-1.273.527H8.4c-.477 0-.935-.19-1.273-.527-.337-.338-.527-.796-.527-1.273V6.6c0-.477.19-.935.527-1.273.338-.337.796-.527 1.273-.527h10.8c.477 0 .935.19 1.273.527.337.338.527.796.527 1.273zm-1.8 0H8.4v7.2h10.8V6.6z"/>
      <path
      d="M13.8 8.4h3.6V12l-3.6-3.6z"/>
    </svg>
  </span>
</template>

<script>
export default {
  name: "Popout",
  props: {
    title: {
      type: String,
      default: ""
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/icons/Popout.vue